module.exports = __webpack_public_path__ + "static/media/compareInactive.4fa25379.png";